import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Table,
  Col,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
// import DefaultImg from "../../../assets/images/product/Default_img.jpg";

import { ExportToExcel } from "../../Common/ExportToExcel";
import { getRfqPendingReportslist } from "../../../store/Reports/actions";
import "../reports.scss";
var date = new Date(),
  y = date.getFullYear(),
  m = date.getMonth();

  
class RfqPendingReportList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getRfqPendingReportslist({
      ...this.props.params,
      start_date:
        this.props.params.start_date == null ||
        this.props.params.start_date === ""
          ? moment(new Date(y, m, 1)).format("YYYY-MM-DD")
          : this.props.params.start_date,
      end_date:
        this.props.params.end_date == null || this.props.params.end_date === ""
          ? moment(new Date()).add(1, "days").format("YYYY-MM-DD")
          : moment(this.props.params.end_date)
              .add(1, "days")
              .format("YYYY-MM-DD"),
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom no-print">
                    <Link
                      to="/RfqPendingReports"
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                    <div className="float-right">
                      <div className="d-inline-block ">
                        <ExportToExcel
                          apiData={this.props.Rfq_pending_ReportData?.map((mr) => {
                            return {
                              "RFQ Code": mr.code,
                              "Date": moment(mr.date).format(
                                "DD-MM-YYYY"
                              ),
                              "Item Name": mr.productname,
                              "Item Description": mr.productdescription,
                              "Qty": mr.qty,
                              "Department": mr.productdepartment,
                              "Vendor Name": mr.vendor_name,
                              "Vendor Code": mr.vendor_code,
                              "Vendor Add Date": moment(mr.vendor_date).format(
                                "DD-MM-YYYY"
                              ),
                              "Vendor Location": mr.vendor_location,
                              "Due Days": mr.no_due_dates,
                              "Status": mr.rfqstatus_name,
                            };
                          })}
                          topHeader={[
                            "SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD",
                            "Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist. - AP",
                            "Phone No.0884-2326661, 62, Mobile No.9494127893, Email: purchase@sleipl.com, lalitharice@gmail.com",
                            "",
                            "RFQ PENDING ITEMS REPORT",
                            "",
                          ]}
                          fileName="RFQ_PENDING_ITEMS_REPORT"
                        />
                        {/* <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" mr-2"
                          onClick={() => this.getExcelReport()}
                        >
                          <i className="ri-file-excel-2-line"></i>
                          <span className="d-none d-inline-block ml-1">
                            Excel
                          </span>
                        </Button> */}
                        {/* <ReactHTMLTableToExcel
                          id="test-table-xls-button"
                          className=" mr-2"
                          // className="download-table-xls-button"
                          table="table-to-xls"
                          filename="tablexls"
                          sheet="tablexls"
                          buttonText="Excel"
                        /> */}
                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" ml-2"
                          onClick={() => window.print()}
                        >
                          <i className="mdi  mdi-printer"></i>
                          <span className="d-none d-inline-block ml-1">
                            Print
                          </span>
                        </Button>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-2">
                    <div className="text-center">
                      <span className="display_none printme">
                        <h5 className="card-title-18 pt-2 ">
                          SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD
                        </h5>
                        <p className="card-title-14 pt-2 mb-0">
                          Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist.
                          - AP
                        </p>
                        <p className="card-title-14 pt-2">
                          Phone No.0884-2326661, 62, Mobile No.9494127893,
                          Email: purchase@sleipl.com, lalitharice@gmail.com
                        </p>
                        <hr />
                      </span>
                      <h5 className="card-title-16 pt-3 ">
                        RFQ PENDING ITEMS REPORT ({" "}
                        {this.props.params.start_date == null ||
                        this.props.params.start_date === ""
                          ? moment(new Date(y, m, 1)).format(
                              "DD-MM-YYYY"
                            )
                          : moment(this.props.params.start_date).format(
                            "DD-MM-YYYY"
                          )}{" "}
                        TO{" "}
                        {moment(this.props.params.end_date).format(
                          "DD-MM-YYYY"
                        )}{" "}
                        )
                      </h5>
                    </div>
                    {/* <div className="Filter-panel-content">
                      <div className="list-column">
                        <Row>
                          <Col md={4}>
                            <ul className="list-style p-0">
                              <li className="clearfix">
                                <span className="ttl">From Date: </span>
                                <span className="dtl">
                                  {this.props.params.start_date}
                                </span>
                              </li>
                              <li className="clearfix">
                                <span className="ttl">To Date:</span>
                                <span className="dtl">
                                  {this.props.params.end_date}
                                </span>
                              </li>
                            </ul>
                          </Col>
                          <Col md={4}>
                            <ul className="list-style p-0">
                              <li className="clearfix">
                                <span className="ttl">Locations: </span>
                                <span className="dtl">
                                  {this.props.params.start_date}
                                </span>
                              </li>
                              <li className="clearfix">
                                <span className="ttl">Sub Location:</span>
                                <span className="dtl">
                                  {this.props.PIreqRowData?.userdepartment.name}
                                </span>
                              </li>
                            </ul>
                          </Col>
                          <Col md={4}>
                            <ul className="list-style p-0">
                              <li className="clearfix">
                                <span className="ttl">User Department:</span>
                                <span className="dtl">
                                  {this.props.params.end_date}
                                </span>
                              </li>
                            </ul>
                          </Col>
                        </Row>
                      </div>
                    </div> */}
                    {/* <div>
                      <Row>
                        <Col md={6}>
                          <span>From Date:</span>
                          <span>
                            {this.props.params.start_date == null
                              ? "all"
                              : this.props.params.start_date}
                          </span>
                        </Col>
                        <Col md={6}></Col>
                      </Row>
                    </div> */}

                    <div className="table-responsive m-0">
                      <Table
                        bordered
                        hover
                        className="mb-0 p-0 table-centered"
                        id="table-to-xls"
                      >
                        <thead className="bg-light text-center">
                          <tr className="bg-light">
                            <th  style={{ width: "5%" }}>
                              <b>RFQ No</b>
                            </th>
                            <th  style={{ width: "5%" }}>
                              <b> Date</b>
                            </th>
                            <th  style={{ width: "10%" }}>
                              <b> Item Name</b>
                            </th>
                            <th  style={{ width: "5%" }}>
                              <b> Item Description</b>
                            </th>
                            <th  style={{ width: "5%" }}>
                              <b> Qty</b>
                            </th>
                            <th  style={{ width: "5%" }}>
                              <b> Department</b>
                            </th>
                            
                            <th  style={{ width: "10%" }}>
                              <b>Vendor Name</b>
                            </th>
                            <th  style={{ width: "10%" }}>
                              <b>Vendor Code</b>
                            </th>
                            <th style={{ width: "10%" }}>
                              <b>Vendor Add Date</b>
                            </th>
                            <th  style={{ width: "10%" }}>
                              <b>Vendor Location</b>
                            </th>
                            <th  style={{ width: "5%" }}>
                              <b>Due days</b>
                            </th>
                            <th  style={{ width: "5%" }}>
                              <b>Status</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.Rfq_pending_ReportData.length !== 0 ? (
                            <>
                              {this.props.Rfq_pending_ReportData?.map((Material, key) => (
                                <>
                                  <tr key={key} className="text-center">
                                    <td>{Material.code}</td>
                                    <td>
                                      {moment(Material.date).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </td>
                                    <td>{Material.productname}</td>
                                    <td>{Material.productdescription}</td>
                                    <td>{Material.qty}</td>
                                    <td>{Material.productdepartment}</td>
                                    <td>{Material.vendor_name}</td>
                                    <td>{Material.vendor_code}</td>
                                    <td>
                                      {moment(Material.vendor_date).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </td>
                                    <td>{Material.vendor_location}</td>
                                    <td>{Material.no_due_dates}</td>
                                    <td>{Material.rfqstatus_name}</td>
                                  </tr>
                                </>
                              ))}
                            </>
                          ) : (
                            <tr>
                              <td colspan="12" className="text-center">
                                <span className="font-size-18 text-danger">
                                  Data not available
                                </span>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { params, reportType, Reportdata, Rfq_pending_ReportData } = state.reports;
  return {
    params,
    reportType,
    Reportdata,
    Rfq_pending_ReportData,
  };
};

export default connect(mapStatetoProps, {
  getRfqPendingReportslist,
})(RfqPendingReportList);
